export default "/images/phone-landscape.svg?7b883ad76d1b57bff016c5ee3c7c9769";